<template><div><h1 id="artikel" tabindex="-1"><a class="header-anchor" href="#artikel"><span>Artikel</span></a></h1>
<p>Artikel — Verwaltet Artikel</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In diesem Frame werden die Artikel verwaltet. lieferantenspezifische Definitionen wie z.B. Einkaufspreise werden unter <RouteLink to="/referenz/refs/ft.refdata.liefartikel.html" title="Artikel (Lieferanten-)">Lieferantenartikel</RouteLink> gepflegt.</p>
<p>Pfad: <code v-pre>Logistik → Artikel</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Hauptartikel</dt>
<dd>
<p>Hauptartikelnummer und Bezeichnung. Es wird nur die deutschsprachige Artikelbezeichnung aus der Tabelle <a class="link" href="ft.refdata.tblhauptartikel.html" title="Hauptartikel">Hauptartikel</a> angezeigt</p>
</dd>
<dt>Anzahl Varianten</dt>
<dd>
<p>Anzahl Varianten, zeigt die Anzahl der zum Hauptartikel zugeordneten Artikel an.</p>
</dd>
<dt>Artikel</dt>
<dd>
<p>Artikelnummer (alphanumerisch)</p>
</dd>
<dt>Bezeichnung</dt>
<dd>
<p>Artikelbezeichnung in 4 Sprachen (d, f, i, e)</p>
</dd>
<dt>Gruppe</dt>
<dd>
<p>Artikelgruppe (mehrere Hierarchien möglich)</p>
</dd>
<dt>Typ</dt>
<dd>
<p>Typ des Artikels:<br>Assembliert (Stückliste), Normalartikel (Standard), Fiktiver Artikel (z.B. Spende).</p>
</dd>
<dt>Art</dt>
<dd>
<p>Artikelart (Porto, Spende oder Ware)</p>
</dd>
<dt>PM</dt>
<dd>
<p><a class="link" href="ft.refdata.tblpm.html" title="Product Manager">Productmanager</a></p>
</dd>
<dt>verfügbar</dt>
<dd>
<p>Verkaufbarer Bestand in allen Lagern. Anzeige der online berechneten Summe der Mengen aller V-Partien.</p>
</dd>
<dt>reserviert</dt>
<dd>
<p>Reservierte Menge. Bei der Auftragserfassung wird eine Verfügbarkeitsprüfung durchgeführt, welche vorhandenen frei verkaufbarem Bestand reserviert, so dass gegenüber dem Kunden eine verbindliche Aussage, ob er den Artikel erhält, gemacht werden kann.</p>
</dd>
<dt>vorreserviert</dt>
<dd>
<p>Vorreservierte Menge. Ist kein frei verfügbarer Bestand vorhanden, erstellt das System bei der Verfügbarkeitsprüfung eine Vorreservierung. Wird eine Lieferung eingebucht, können vorreservierte Bestände in reservierte umgebucht werden. Siehe <a class="link" href="ft.refproc.artumbuchen.html" title="Artikel umbuchen">Artikel umbuchen</a>.</p>
</dd>
<dt>Gesamtbestand</dt>
<dd>
<p>Gesamtbestand in allen Lagern; Anzeige der online berechneten Summe der Mengen sämtlicher Partien.</p>
</dd>
<dt>letzte Inventur</dt>
<dd>
<p>Datum der letzten Inventur.</p>
</dd>
<dt>Bestellpunkt</dt>
<dd>
<p>Artikelmenge, die eine Benachrichtigung des Einkaufs für Nachbestellungen auslöst.</p>
</dd>
<dt>nächste Lieferung</dt>
<dd>
<p>Anzeige der Artikelmenge aus der nächsten zu erwartenden Lieferung.</p>
</dd>
<dt>Lieferdatum</dt>
<dd>
<p>Anzeige des Datums der nächsten zu erwartenden Lieferung.</p>
</dd>
<dt>Grenzbestand</dt>
<dd>
<p>Wird verwendet, um einen Minimalbestand eines Artikels nicht zu unterschreiten, damit der Bedarf für Schnellversand gedeckt werden kann.</p>
</dd>
<dt>Warnmenge</dt>
<dd>
<p>Wird bei der Auftragserfassung diese Menge / Anzahl eingegeben, so zeigt das System eine Warnmeldung. Wird häufig verwendet bei Artikeleinheiten, die nicht in Stk. gepflegt werden, wie z.B. Karton mit mehreern Artikeln, Sets.</p>
</dd>
<dt>Status</dt>
<dd>
<p>Bewirtschaftungsstatus, der manuell gepflegt werden kann</p>
<table>
<thead>
<tr>
<th>Code</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td></td>
<td>(Ohne Bezeichnung) normale Bewirtschaftung</td>
</tr>
<tr>
<td>Auslaufartikel</td>
<td>Dieser Artikel wird im Avisierungssystem speziell behandelt (ein Auftrag wird abgeschlossen, selbst dann, wenn der Artikel nicht mehr lieferbar ist).</td>
</tr>
</tbody>
</table>
</dd>
<dt>absagen ab</dt>
<dd>
<p>Anzahl vorreservierter Artikel, ab der neu erfasste Auftragspositionen abgesagt werden. Die Angabe ist nur gültig bei Artikeln mit Status &quot;Auslaufartikel&quot;.</p>
</dd>
<dt>Text auf WBS</dt>
<dd>
<p>Die <a class="link" href="ft.refdata.tbltextart.html" title="Textzeilen zum Artikel">Textzeilen zum Artikel</a> werden auf dem WBS gedruckt, wobei für verschiedene Liefersituationen unterschiedliche Texte eingegeben werden können.</p>
</dd>
<dt>Bestandteile zeigen?</dt>
<dd>
<p>Bestandteile auf dem WBS drucken?<br>Nur für Assemblierte Artikel, bei Normalartikel ist das Feld nicht editierbar</p>
</dd>
<dt>Verkaufspreis LW</dt>
<dd>
<p>Verkaufspreis in Landeswährung.</p>
</dd>
<dt>neuer Preis LW</dt>
<dd>
<p>Neuer Verkaufspreis in Landeswährung, Gültigkeitsdatum ab. Wird hier ein Preis und ein zukünftiges Datum eingegeben, wird der Verkaufspreis ab diesem Zeitpunkt auf den neuen Preis angepasst.</p>
</dd>
<dt>Verkaufspreis FW</dt>
<dd>
<p>Verkaufspreis in Fremdwährung (Auswahl).</p>
</dd>
<dt>neuer Preis FW</dt>
<dd>
<p>Neuer Verkaufspreis in Fremdwährung, Gültigkeitsdatum ab. Wird hier ein Preis und ein zukünftiges Datum eingegeben, wird der Verkaufspreis FW ab diesem Zeitpunkt auf den neuen Preis angepasst.</p>
</dd>
<dt>Artikelrabattcode</dt>
<dd>
<p><a class="link" href="../../manual/trade/rabattstufen.html" title="9.2.2.1. Daten Artikel-Rabattcode">Artikelrabatt</a> für die Rabattberechnung.</p>
</dd>
<dt>MWSt</dt>
<dd>
<p><a class="link" href="ft.refdata.tblmwst.html" title="MWST-Codes">Mehrwertsteuer-Code</a>.</p>
</dd>
<dt>Einstandspreis</dt>
<dd>
<p>Einstandspreis pro Einheit. Bei Bedarf kann der Einstandspreis durch das System aufgrund der Daten im <a class="link" href="ft.refdata.liefartikel.html" title="Artikel (Lieferanten-)">Lieferantenartikel</a> berechnet werden.</p>
</dd>
<dt>Preis änderbar</dt>
<dd>
<p>Mit diesem Schalter wird festgelegt, ob der Artikelpreis in den Auftragspositionen manuell angepasst werden darf.</p>
</dd>
<dt>Marge (%)</dt>
<dd>
<p>Anzeige der Marge. Die Marge wird anhand vom Einkaufs- und Verkaufspreis und der Berücksichtigung der Mehrwertsteuer automatisch berechnet. Die Formel lautet: (Verkaufspreis - MWST - Einstandspreis) * 100 / (Verkaufspreis - MWST)</p>
</dd>
<dt>Spendenereignis</dt>
<dd>
<p>Ereignis/ Ereignisposition welche für einem Spendenartikel festgelegt werden müssen.</p>
</dd>
<dt>Grösse</dt>
<dd>
<p>Artikelgrösse individuell nach Artikel verschieden. z.B. Konfektion S, M, L, XL oder Schuhe 38, 40, 41, etc.</p>
</dd>
<dt>Farbe</dt>
<dd>
<p>Farbe des Artikels in Farbeinheiten, z.B. rot, weiss, blau, oder rot-weiss, etc.</p>
</dd>
<dt>Einheit</dt>
<dd>
<p><a class="link" href="ft.refdata.tbleinheit.html" title="Einheiten">Artikeleinheit</a></p>
</dd>
<dt>Volumen (cm3)</dt>
<dd>
<p>Artikelvolumen</p>
</dd>
<dt>Gewicht (g)</dt>
<dd>
<p>Gewicht des Artikels in Gramm, kann in der Berechnung von Portokosten genutzt werden.</p>
</dd>
<dt>Länge, Breite, Höhe (cm)</dt>
<dd>
<p>Abmessungen des Artikels</p>
</dd>
<dt>Ertragskonto</dt>
<dd>
<p>Ertragskonto gemäss Tabelle <a class="link" href="ft.refdata.konti.html" title="Konti">Konti</a>.</p>
</dd>
<dd>
<p>Ertragskostenstelle gemäss Tabelle <a class="link" href="ft.refdata.kst.html" title="Kostenstellen">Kostenstellen</a></p>
</dd>
<dd>
<p>Ertragskostenträger gemäss Tabelle <a class="link" href="ft.refdata.ktr.html" title="Kostenträger">Kostenträger</a></p>
</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="einstandspreis-berechnen" tabindex="-1"><a class="header-anchor" href="#einstandspreis-berechnen"><span>Einstandspreis berechnen</span></a></h3>
<p>Der Preis wird ausgehend vom Standard-<RouteLink to="/referenz/refs/ft.refdata.liefartikel.html" title="Artikel (Lieferanten-)">Lieferantenartikel</RouteLink> wie folgt berechnet:</p>
<p>L-Preis - Rabatt + Spesen * Währung, wobei nur die Angaben aus der ersten Zeile berücksichtigt werden.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refproc.artumbuchen.html" title="Artikel umbuchen">Artikel umbuchen</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.tbleinheit.html" title="Einheiten">Artikeleinheit</RouteLink>, <RouteLink to="/manual/trade/rabattstufen.html#ft.refdata.tblartrabatt" title="9.2.2.1. Daten Artikel-Rabattcode">Artikelrabatt</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.tblhauptartikel.html" title="Hauptartikel">Hauptartikel</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.konti.html" title="Konti">Konti</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.kst.html" title="Kostenstellen">Kostenstellen</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.ktr.html" title="Kostenträger">Kostenträger</RouteLink>, <RouteLink to="/manual/trade/artikel_und_lagerverwaltung.html" title="3. Artikel- und Lagerverwaltung">Lagerverwaltung</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.tblmwst.html" title="MWST-Codes">Mehrwertsteuer-Code</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.tblpm.html" title="Product Manager">Productmanager</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.tbltextart.html" title="Textzeilen zum Artikel">Textzeilen zum Artikel</RouteLink></p>
</div></template>


